import BookingOptionsFilter from '@pages/FlightSearchResult/components/FlightFilters/BookingOptionsFilter';
import BookingSitesFilter from '@pages/FlightSearchResult/components/FlightFilters/BookingSitesFilter';
import DurationFilter from '@pages/FlightSearchResult/components/FlightFilters/DurationFilter';
import FlightExperiencesFilter from '@pages/FlightSearchResult/components/FlightFilters/FlightExperiencesFilter';
import NewAirlinesFilter from '@pages/FlightSearchResult/components/FlightFilters/NewAirlinesFilter';
import NewFlightTimesFilter from '@pages/FlightSearchResult/components/FlightFilters/NewFlightTimesFilter';
import NewPriceFilter from '@pages/FlightSearchResult/components/FlightFilters/NewPriceFilter';
import OriginDestinationFilter from '@pages/FlightSearchResult/components/FlightFilters/OriginDestinationFilter';
import PaymentMethodsFilter from '@pages/FlightSearchResult/components/FlightFilters/PaymentMethodsFilter';
import StopoverAirportsFilter from '@pages/FlightSearchResult/components/FlightFilters/StopoverAirportsFilter';
import StopsFilter from '@pages/FlightSearchResult/components/FlightFilters/StopsFilter';
import { FlightFilterCategories } from '@pages/FlightSearchResult/components/FlightFilters/type';
import React from 'react';

import styles from './FilterPopupContent.module.scss';

type FilterPopupContentProps = {
  availablePaymentMethods: HomepageFlightsPaymentMethod[];
  genzoTrackApplyFilterActionEvent: any;
  genzoTrackApplyFilterSearchView: () => void;
  selectedFilterDropdown: FlightFilterCategories;
};

const FilterPopupContent: React.FC<FilterPopupContentProps> = ({
  availablePaymentMethods,
  genzoTrackApplyFilterActionEvent,
  genzoTrackApplyFilterSearchView,
  selectedFilterDropdown,
}) => {
  switch (selectedFilterDropdown) {
    case FlightFilterCategories.Stops:
      return (
        <StopsFilter
          className={styles.sortAndFilterBarElement}
          genzoTrackApplyFilterActionEvent={genzoTrackApplyFilterActionEvent}
          genzoTrackApplyFilterSearchView={genzoTrackApplyFilterSearchView}
        />
      );

    case FlightFilterCategories.PaymentMethod:
      return (
        <PaymentMethodsFilter
          className={styles.sortAndFilterBarElement}
          availablePaymentMethods={availablePaymentMethods}
          genzoTrackApplyFilterActionEvent={genzoTrackApplyFilterActionEvent}
        />
      );

    case FlightFilterCategories.BookingOptions:
      return (
        <BookingOptionsFilter
          className={styles.sortAndFilterBarElement}
          genzoTrackApplyFilterActionEvent={genzoTrackApplyFilterActionEvent}
          genzoTrackApplyFilterSearchView={genzoTrackApplyFilterSearchView}
        />
      );

    case FlightFilterCategories.BookingSites:
      return (
        <BookingSitesFilter
          disableCollapse
          className={styles.sortAndFilterBarElement}
          genzoTrackApplyFilterActionEvent={genzoTrackApplyFilterActionEvent}
          genzoTrackApplyFilterSearchView={genzoTrackApplyFilterSearchView}
        />
      );

    case FlightFilterCategories.Experience:
      return (
        <FlightExperiencesFilter
          className={styles.sortAndFilterBarElement}
          genzoTrackApplyFilterSearchView={genzoTrackApplyFilterSearchView}
          genzoTrackApplyFilterActionEvent={genzoTrackApplyFilterActionEvent}
        />
      );

    case FlightFilterCategories.OriginAndDestination:
      return (
        <OriginDestinationFilter
          className={styles.sortAndFilterBarElement}
          genzoTrackApplyFilterSearchView={genzoTrackApplyFilterSearchView}
          genzoTrackApplyFilterActionEvent={genzoTrackApplyFilterActionEvent}
        />
      );

    case FlightFilterCategories.Transit:
      return (
        <StopoverAirportsFilter
          className={styles.sortAndFilterBarElement}
          disableCollapse
          genzoTrackApplyFilterSearchView={genzoTrackApplyFilterSearchView}
          genzoTrackApplyFilterActionEvent={genzoTrackApplyFilterActionEvent}
        />
      );

    case FlightFilterCategories.Duration:
      return (
        <DurationFilter
          className={styles.sortAndFilterBarElement}
          genzoTrackApplyFilterActionEvent={genzoTrackApplyFilterActionEvent}
          genzoTrackApplyFilterSearchView={genzoTrackApplyFilterSearchView}
        />
      );

    case FlightFilterCategories.Times:
      return (
        <NewFlightTimesFilter
          isPadded
          genzoTrackApplyFilterActionEvent={genzoTrackApplyFilterActionEvent}
        />
      );

    case FlightFilterCategories.Price:
      return (
        <NewPriceFilter
          isPadded
          genzoTrackApplyFilterActionEvent={genzoTrackApplyFilterActionEvent}
          genzoTrackApplyFilterSearchView={genzoTrackApplyFilterSearchView}
        />
      );

    case FlightFilterCategories.Airlines:
      return (
        <NewAirlinesFilter
          className={styles.sortAndFilterBarElement}
          genzoTrackApplyFilterActionEvent={genzoTrackApplyFilterActionEvent}
          genzoTrackApplyFilterSearchView={genzoTrackApplyFilterSearchView}
        />
      );

    default:
      return <></>;
  }
};

export default FilterPopupContent;
